/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddAdhocContactRequest
 */
export interface AddAdhocContactRequest {
    /**
     * 
     * @type {string}
     * @memberof AddAdhocContactRequest
     */
    adHocName: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddAdhocContactRequest
     */
    adHocEmail: string | null;
}

/**
 * Check if a given object implements the AddAdhocContactRequest interface.
 */
export function instanceOfAddAdhocContactRequest(value: object): value is AddAdhocContactRequest {
    if (!('adHocName' in value) || value['adHocName'] === undefined) return false;
    if (!('adHocEmail' in value) || value['adHocEmail'] === undefined) return false;
    return true;
}

export function AddAdhocContactRequestFromJSON(json: any): AddAdhocContactRequest {
    return AddAdhocContactRequestFromJSONTyped(json, false);
}

export function AddAdhocContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddAdhocContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'adHocName': json['adHocName'],
        'adHocEmail': json['adHocEmail'],
    };
}

export function AddAdhocContactRequestToJSON(value?: AddAdhocContactRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'adHocName': value['adHocName'],
        'adHocEmail': value['adHocEmail'],
    };
}

